import {
  IValidatePasswordRecoveryCodeParams,
  TValidatePasswordRecoveryCodeResponse,
} from 'modules/authentication/domain/repositories/IValidatePasswordRecoveryCodeRepository';
import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';

export default class VectisPasswordRecoveryCodeRepository {
  constructor(private httpProvider: IHTTPProvider) {}

  public validate = async ({
    document,
    code,
    entityId,
  }: IValidatePasswordRecoveryCodeParams): Promise<TValidatePasswordRecoveryCodeResponse> => {
    const data = await this.httpProvider.post<{
      valido: boolean;
      mensagem?: string;
      idLogTentativaValidacaoCodigoConfirmacao: number;
      idCliente: number;
    }>('/codigoConfirmacao/validarCodigoRecuperacaoSenha', {
      cpf: document,
      codigo: code,
      idEntidade: entityId ?? '0',
      processo: 'RECUPERACAO_SENHA',
    });

    return {
      id: data.idLogTentativaValidacaoCodigoConfirmacao,
      valid: data.valido,
      message: data.mensagem,
      idClient: data.idCliente,
    };
  };
}
